<template>
  <div class="subtitle-position">
    <div class="title">字幕位置</div>
    <div class="menu">
      <div
        class="menu-title"
        @click="onClickMenu($event)"
      >
        <span>{{activeOption.text}}</span>
        <i class="tri"></i>
      </div>
      <ul
        class="options"
        :style="{display: isShowOptions ? 'block' : 'none'}"
      >
        <li
          class="option"
          v-for="(option, i) in options"
          :key="i"
          @click="select(option)"
        >{{option.text}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data () {
    return {
      isShowOptions: false,
      activeIndex: 0,
      options: [
        { text: '底部对齐', name: 'bottom' },
        { text: '顶部对齐', name: 'top' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      subtitle: 'subtitle/selectSubtitle'
    }),
    activeOption () {
      return this.options[this.activeIndex];
    }
  },
  created () {
    this.$watch(function () {
      if (this.subtitle) {
        return this.subtitle.outward
      }
    }, function (val, oldVal) {
      if (val) {
        let subtitleHeight
        try {
          subtitleHeight = this.subtitle.outward.height;
        } catch (e) {
          subtitleHeight = 0
        }
        let isTop = val.y === 50;
        let isBottom = val.y === 1080 - 50 - subtitleHeight;
        if (isTop) {
          this.activeIndex = 1;
        } else if (isBottom) {
          this.activeIndex = 0;
        }
      }
    }, {
      deep: true
    });
  },
  mounted () {
    let container = document.querySelector('#subtitle');
    container.addEventListener('click', () => {
      this.isShowOptions = false;
    });
  },
  methods: {
    onClickMenu (ev) {
      if (!this.isShowOptions) {
        ev.stopPropagation();
        this.isShowOptions = true
      }
    },
    select (item) {
      if (item.name === 'top') {
        this.alignTop();
        this.activeIndex = 1;
      }
      if (item.name === 'bottom') {
        this.alignBottom();
        this.activeIndex = 0;
      }
    },
    alignTop () {
      let subtitleHeight = 0;
      let subtitleWidth = 0;
      try {
        subtitleHeight = this.subtitle.outward.height;
        subtitleWidth = this.subtitle.outward.width;
      } catch (e) {
        }
      this.$store.commit('subtitle/updateSubtitleUndo', {
        subtitle: {
          outward: {
            x: (1920 - subtitleWidth ) / 2,
            y: 50
          }
        }
      });
    },
    alignBottom () {
      let subtitleHeight = 0;
      let subtitleWidth = 0;
      try {
        subtitleHeight = this.subtitle.outward.height;
        subtitleWidth = this.subtitle.outward.width;
      } catch (e) {
      }
      this.$store.commit('subtitle/updateSubtitleUndo', {
        subtitle: {
          outward: {
            x: (1920 - subtitleWidth ) / 2,
            y: 1080 - 50 - subtitleHeight
          }
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.subtitle-position {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title {
  font-size: 12px;
  color: #474261;
}
.menu {
  position: relative;
}
.menu-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 163px;
  height: 28px;
  background: #ffffff;
  border: 1px solid #d9ddea;
  border-radius: 4px;
  font-size: 12px;
  color: #737596;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
}
.options {
  display: none;
  position: absolute;
  top: calc(100% + 6px);
  font-size: 12px;
  color: #737596;
  width: 163px;
  border: 1px solid #d9ddea;
  border-radius: 4px;
  background-color: #fff;
}
.option {
  height: 28px;
  line-height: 28px;
  cursor: pointer;
  &:hover {
    background-color: #d9ddea;
  }
}
.tri {
  border-top: 6px solid #737596;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 0 solid transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/subtitlePanel/subtitlePosition.vue